import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=6af82b8a&scoped=true"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=6af82b8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af82b8a",
  null
  
)

export default component.exports